import axios from '@/api/http.js'

const URLS = {
    list: 'reminders/',
    create: 'reminders/',
    byId: (id) => `reminders/${id}/`,
    acknowledge: (id) => `reminders/${id}/acknowledge/`,
    cancel: (id) => `reminders/${id}/cancel/`,
}

export default {
    async list(params = {}) {
        const { data } = await axios.get(URLS.list, { params })
        return data // { count, next, previous, results }
    },
    async create(payload) {
        // payload соответствует ReminderCreateUpdate
        const { data } = await axios.post(URLS.create, payload)
        return data
    },
    async get(id) {
        const { data } = await axios.get(URLS.byId(id))
        return data
    },
    async acknowledge(id) {
        const { data } = await axios.post(URLS.acknowledge(id))
        return data
    },
    async cancel(id) {
        const { data } = await axios.post(URLS.cancel(id))
        return data
    },
}